module.exports = __webpack_public_path__ + "img/privacy-policy-m.1b70dea.webp";